import appClient from '../../common/services/AppClient';
import {
    Script,
    CreateScriptRequest,
    UpdateScriptRequest,
    ScriptUsageResult,
    UsageInProjects,
    ExecuteDryRunRequest,
    SqlExecutionResult,
    EnvironmentListResponse
} from '../types';
import { endpoints } from '../../../config';

export default class ScriptManagementService {
    async getScripts() {
        const url = `${endpoints.manageUrl}scripts`;
        const resp = await appClient.get<Script[]>(url);
        return resp.unwrapOr([]);
    }

    async createScript(data: CreateScriptRequest) {
        const url = `${endpoints.manageUrl}scripts`;
        return appClient.post<Script>(url, data);
    }

    async updateScript(scriptId: string, data: UpdateScriptRequest) {
        const url = `${endpoints.manageUrl}scripts/${scriptId}`;
        return appClient.update(url, data);
    }

    async deleteScript(scriptId: string) {
        const url = `${endpoints.manageUrl}scripts/${scriptId}`;
        return appClient.delete(url);
    }

    async getScript(scriptId: string) {
        const url = `${endpoints.manageUrl}scripts/${scriptId}`;
        const resp = await appClient.get<Script>(url);
        return resp.unwrapOr({} as Script);
    }

    async checkScriptUsage(scriptId: string) {
        const url = `${endpoints.manageUrl}scripts/${scriptId}/usage`;
        const resp = await appClient.get<ScriptUsageResult[]>(url);
        return resp.unwrapOr([]);
    }

    async checkScriptUsageInProjects(scriptIds: string[]) {
        const url = `${endpoints.manageUrl}scripts/usage-in-projects`;
        const resp = await appClient.post<UsageInProjects[]>(url, { scriptIds });
        if (resp.isErr()) {
            throw resp.error;
        }
        return resp.value;
    }

    async restoreScriptRevision(scriptId: string, revisionId: string) {
        const url = `${endpoints.manageUrl}scripts/${scriptId}/restore/${revisionId}`;
        return appClient.post<Script>(url);
    }

    async executeDryRun(data: ExecuteDryRunRequest) {
        const url = `${endpoints.manageUrl}scripts/dry-run`;
        const resp = await appClient.post<SqlExecutionResult>(url, data);
        return resp;
    }

    async getEnvironments(endpointUrl?: string) {
        let url = `${endpoints.manageUrl}scripts/environments`;
        if (endpointUrl) {
            url += `?endpointUrl=${encodeURIComponent(endpointUrl)}`;
        }
        const resp = await appClient.get<EnvironmentListResponse>(url);
        return resp;
    }
}
